import { render, staticRenderFns } from "./CustomerAdditionalGuestsEditCard.vue?vue&type=template&id=6c95a810&scoped=true&"
import script from "./CustomerAdditionalGuestsEditCard.vue?vue&type=script&lang=js&"
export * from "./CustomerAdditionalGuestsEditCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAdditionalGuestsEditCard.vue?vue&type=style&index=0&id=6c95a810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c95a810",
  null
  
)

/* custom blocks */
import block0 from "./CustomerAdditionalGuestsEditCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCheckbox,VCol,VForm,VRow,VTextField})
